import axios from "axios";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import OTPMessage from "../../../constants/OTP/OTP.json";
import { request } from "../api";

const { post } = request;
const initialRoute = "OTP";

type SendToEmailPayload = {
	email: string;
	type: string;
};

type VerifyEmailPayload = {
	otp: string;
	check: string;
	verification_key: string;
};

export const sendToEmail = async (_payload: SendToEmailPayload): Promise<string> => {
	try {
		const endpoint = `${initialRoute}/email`;
		const payload = JSON.stringify(_payload);
		const response = await post(endpoint, payload, headers);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.post.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const verifyOTP = async (_payload: VerifyEmailPayload): Promise<boolean | undefined> => {
	try {
		const payload = JSON.stringify(_payload);
		const endpoint = `${initialRoute}/verify`;
		const response = await post(endpoint, payload, headers);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === OTPMessage["OTP matched"]) {
				return true;
			}
		}
		//throw new Error();
	} catch (err) {
		if (axios.isAxiosError(err)) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			if (err!.response!.status === 400) {
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				const { message } = err!.response!.data;
				alert(message);
			}
		}
	}
};

export const OTP = {
	sendToEmail,
	verifyOTP
};
